import { MoneyLenderTilesProps } from 'types/MoneyLenders';
import { http } from '../http';

export const getMoneyLenderTiles = async (): Promise<MoneyLenderTilesProps[]> => {
  const response = await http.get('api/moneylenders/tiles');

  return response.data;
};
